export default "__VITE_ASSET__OBzLuN28__"